
import { formatMoney } from '@/utils/utilities';

/**
 * @component TableComponent
 *
 * @prop {String} selectedAgent
 * @prop {Number} costBodeSeller
 * @prop {Number} costBodeBuyer
 * @prop {Number} costAgentSeller
 * @prop {Number} costAgentBuyer
 */

export default {
  name: 'TableComponent',
  props: {
    role: {
      type: String,
      default: 'seller',
    },
    selectedAgent: {
      type: String,
      default: 'Bode',
    },
    costBodeSeller: {
      type: Number,
      required: true,
    },
    costBodeBuyer: {
      type: Number,
      required: true,
    },
    costAgentSeller: {
      type: Number,
      required: true,
    },
    costAgentBuyer: {
      type: Number,
      required: true,
    },
  },
  computed: {
    /**
      * Returns the total cost of using an agent.
      *
      * @return {Number}
      * @private
      */

    totalBode() {
      if (this.role === 'buyer') return 0;
      return Math.round(this.costBodeSeller + this.costBodeBuyer);
    },

    /**
      * Returns the total cost of using an agent.
      *
      * @return {Number}
      * @private
      */

    totalAgent() {
      if (this.role === 'buyer') return Math.round(this.costAgentBuyer);
      return Math.round(this.costAgentSeller + this.costAgentBuyer);
    },
  },
  methods: {

    /**
     * Format number with commas as thousands separators.
      *
      ≈ @param {Number} nb
      * @return {String}
      * @private
      */

    format(nb) {
      return formatMoney(nb);
    },
  },
};
